export default __webpack_public_path__ + "static/media/is_this_you_xl.1773449d.jpg";